import { useSyncExternalStore } from 'react';

import { CapabilityName } from '~configs/capabilities';
import { permissionRolloutConfigService } from '~services/permission-rollout-config.service';
import { canAccessCapability } from '~utils/can-access-capability.util';

/**
 * Reactive capability check against the central registry
 * (`~configs/capabilities`). Re-evaluates when the permission rollout config
 * loads or changes, so gates flip live like `RolesRestrict` does.
 *
 * Usage: `const canAccess = useCan('pinning.workflow.access');`
 */
export const useCan = (capability: CapabilityName): boolean => {
  useSyncExternalStore(
    permissionRolloutConfigService.subscribe,
    permissionRolloutConfigService.getSnapshot,
  );

  return canAccessCapability(capability);
};
